export type EventChangeKind = 'rescheduled' | 'postponed' | 'cancelled';
export const isEventClosed = (event: { lifecycle_status?: string | null } | null | undefined) =>
  event?.lifecycle_status === 'cancelled' || event?.lifecycle_status === 'postponed';
export const centralEventDate = (date: string) => new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Chicago', weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
  hour: 'numeric', minute: '2-digit', timeZoneName: 'short',
}).format(new Date(date)) + ' (America/Chicago)';
export const changeHeading = (kind: string) => kind === 'rescheduled' ? 'Event rescheduled'
  : kind === 'postponed' ? 'Event postponed — date TBD' : 'Event cancelled';
export const reminderKey = (type: string, revision: number) => revision > 0 ? `${type}:schedule-${revision}` : type;
export interface SyntheticRecipient { email: string; status: string; channel: 'member' | 'guest' }
export function uniqueConfirmedEmails(recipients: SyntheticRecipient[]) {
  return [...new Set(recipients.filter(r => r.status === 'rsvp').map(r => r.email.trim().toLowerCase()).filter(Boolean))];
}
export const deliveryKey = (changeId: string, recipient: string, channel: string) =>
  `${changeId}:${channel}:${recipient.trim().toLowerCase()}`;
export function scheduleMatches(event: { date: string; lifecycle_status?: string | null }, queuedDate: string) {
  return !isEventClosed(event) && new Date(event.date).getTime() === new Date(queuedDate).getTime();
}
